import Vue from "vue";
import Router from "vue-router";
import FrameRoutes from "./common/frame_router";
import CoopRoutes from "./common/coop_router";
import BiddingRoutes from "./common/bidding_router";
import PsiRoutes from "./common/psi_router";
import StatRoutes from "./common/stat_router";
import FinanceRoutes from "./common/finance_router";
import store from "./store";

/* 使用路由依赖 */
Vue.use(Router);

/* 定义路由 */
const router = new Router({
    mode: "history",
    routes: [
        ...FrameRoutes,
        ...CoopRoutes,
        ...BiddingRoutes,
        ...PsiRoutes,
        // ...StatRoutes,
        ...FinanceRoutes,
        { path: "*", component: () => import("@/routes/exception/404") }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    // 小程序webview场景：URL携带clscm.session.id参数，用于恢复登录态
    const mpToken = to.query['clscm.session.id'];
    if (mpToken) {
        // 持久化 token，request.js 读取后作为 token header 发送（不依赖 cookie）
        localStorage.setItem('MP_SESSION', mpToken);
    }
    if (mpToken && !localStorage.getItem('IMS_USER')) {
        try {
            const res = await fetch('/java2api/ims/currentUser', {
                credentials: 'include',
                headers: { token: mpToken }
            });
            const data = await res.json();
            if (data.state === 1 && data.data) {
                localStorage.setItem('IMS_USER', JSON.stringify(data.data));
            }
        } catch (e) {
            // 网络异常忽略，后续仍按未登录处理
        }
    }

    const user = JSON.parse(localStorage.getItem("IMS_USER"));
    if (user != null) {
        if (Object.keys(store.state.ImsUsers.BaseInfo).length == 0) {
            if (mpToken) {
                // webview 场景：先放行渲染页面，initUserInfo 在后台加载，避免白屏等待
                store.dispatch("ImsUsers/initUserInfo").catch(() => {});
                next();
            } else {
                store.dispatch("ImsUsers/initUserInfo").then(() => {
                    next();
                }).catch(() => {
                    next();
                });
            }
        } else {
            next();
        }
    } else {
        if (to.name === "login")
            next();
        else {
            if (window.top === window) {
                window.top.location.href = "/login";
            } else {
                window.top.location.href = "/login?origin=" + location.origin + "&pathname=" + location.pathname;
            }
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js